import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 8,
	viewBox: "0 0 12 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11 1.17006C10.8126 0.983808 10.5592 0.879272 10.295 0.879272C10.0308 0.879272 9.77737 0.983808 9.59 1.17006L6 4.71006L2.46 1.17006C2.27263 0.983808 2.01918 0.879272 1.755 0.879272C1.49082 0.879272 1.23737 0.983808 1.05 1.17006C0.95627 1.26303 0.881875 1.37363 0.831107 1.49549C0.780338 1.61735 0.754199 1.74805 0.754199 1.88006C0.754199 2.01207 0.780338 2.14278 0.831107 2.26464C0.881875 2.3865 0.95627 2.4971 1.05 2.59006L5.29 6.83006C5.38296 6.92379 5.49356 6.99818 5.61542 7.04895C5.73728 7.09972 5.86798 7.12586 6 7.12586C6.13202 7.12586 6.26271 7.09972 6.38458 7.04895C6.50644 6.99818 6.61703 6.92379 6.71 6.83006L11 2.59006C11.0937 2.4971 11.1681 2.3865 11.2189 2.26464C11.2697 2.14278 11.2958 2.01207 11.2958 1.88006C11.2958 1.74805 11.2697 1.61735 11.2189 1.49549C11.1681 1.37363 11.0937 1.26303 11 1.17006Z",
		fill: "black"
	})
});
export default SvgDown;
